export const TRANSLATIONS_COLLABORATORS_DETAIL = {
  collaboratorsMetrics: {
    title: 'collaborators_detail.index',
    metrics: 'collaborators_detail.metrics'
  },
  status: {
    title: 'csp.status',
    active: 'csp.active',
    inactive: 'csp.inactive',
    all: 'csp.all'
  },
  plan: {
    title: 'csp.plan'
  },
  gender: {
    title: 'csp.gender.index',
    female: 'csp.gender.female',
    male: 'csp.gender.male',
    nonBinary: 'csp.gender.other'
  },
  generation: {
    title: 'csp.generation.index',
    silentGeneration: 'csp.generation.silent_generation',
    babyBoomer: 'csp.generation.baby_boomer',
    generationX: 'csp.generation.generation_x',
    millennial: 'csp.generation.millennial',
    centennial: 'csp.generation.generation_z',
    generationAlpha: 'csp.generation.generation_alpha'
  },
  sendEmail: {
    sent: 'button.sent',
    sendEmail: 'button.send_email',
    tooltip: 'tooltip.email_reminder'
  },
  masiveEmail: {
    text: 'collaborators_detail.monthly_email.description',
    button: 'button.send'
  },
  table: {
    name: 'csp.name',
    documentValue: 'csp.id',
    agreement: 'csp.agreement',
    entry: 'csp.entry',
    withoutCollaborators: 'banner.information.collaborators_detail.without_collaborators'
  },
  toolbar: {
    employeesSelected: 'collaborators_detail.toolbar.employees_selected',
    employeesSelectedPlural: 'collaborators_detail.toolbar.employees_selected_plural',
    deleteButton: 'collaborators_detail.toolbar.delete_button',
    deleteButtonPlural: 'collaborators_detail.toolbar.delete_button_plural',
    actionButton: 'collaborators_detail.toolbar.action_button'
  },
  collaboratorsTable: {
    title: 'collaborators_detail.collaborators_table.title',
    searchPlaceholder: 'collaborators_detail.collaborators_table.search_placeholder',
    downloadCollaborators: 'button.download_collaborators',
    header: {
      email: 'csp.email',
      name: 'csp.name',
      documentValue: 'csp.id',
      entry: 'csp.entry',
      birth: 'csp.birth'
    },
    empty: {
      title: 'collaborators_detail.collaborators_table.empty.title',
      description: 'collaborators_detail.collaborators_table.empty.description',
      addCollaborators: 'csp.add_collaborators',
      noResults: 'collaborators_detail.collaborators_table.empty.no_results'
    }
  },
  deleteCollaborator: {
    title: 'collaborators_detail.delete_collaborator.title',
    titlePlural: 'collaborators_detail.delete_collaborator.title_plural',
    description: 'collaborators_detail.delete_collaborator.description',
    descriptionPlural: 'collaborators_detail.delete_collaborator.description_plural',
    deleteButton: 'collaborators_detail.toolbar.delete_button',
    deleteButtonPlural: 'collaborators_detail.toolbar.delete_button_plural',
    cancelButton: 'button.cancel'
  },
  filter: {
    searchDetail: 'csp.searcher_detail',
    searchMobile: 'csp.search',
    downloadCollaborators: 'button.download_collaborators'
  },
  maxCollaboratorsInfo: 'banner.information.max_500_collaborators',
  maxMembersInfo: 'banner.information.max_members',
  resendInvitationEmail: {
    title: 'collaborators_detail.resend_invitation_email.title',
    titlePlural: 'collaborators_detail.resend_invitation_email.title_plural',
    description: 'collaborators_detail.resend_invitation_email.description',
    descriptionPlural: 'collaborators_detail.resend_invitation_email.description_plural',
    sendButton: 'button.resend_email',
    sendButtonPlural: 'button.resend_email_plural',
    cancelButton: 'button.cancel',
    cardStatus: 'collaborators_detail.resend_invitation_email.card_status',
    cardStatusPlural: 'collaborators_detail.resend_invitation_email.card_status_plural',
    reinviteButton: 'button.reinvite'
  },
  sendMembersEmailModal: {
    title: 'collaborators.send_collaborators_list.title',
    description: 'collaborators.send_collaborators_list.description',
    cancelButton: 'button.close'
  }
};

export const TRANSLATIONS_COLLABORATOR_STATUS: { [key: string]: string } = {
  all: 'csp.all',
  active: 'csp.active',
  inactive: 'csp.inactive',
  invited: 'csp.invited',
  in_progress: 'csp.in_progress'
};
